export default "__VITE_ASSET__56889326__"